<section>																			  
  <p-messages key="ballisticEvidenceSearchMsg" [closable]="true"></p-messages>
  <div class="card mb-3">
    <div class="card-body">
      <form [formGroup]="searchForm">
        <div class="row row-cols-md-auto g-3 align-items-start">
          <div class="col-12">
            <label for="searchField" class="form-label required-field">Search by</label>
            <select #searchFieldSelect id="searchField" class="form-select" formControlName="SearchField" (change)="onSelectSearchField(searchFieldSelect.value)" required aria-required="true">
              <option value="">Select search type</option>
              <option value="LECaseNumber">LE Case &#35;</option>
              <option value="LabCaseNumber">NIBIN Case &#35;</option>
              <option value="SerialNumber">Firearm Serial &#35;</option>
              <option value="FTSID">FTS ID</option>
              <option value="CrimeGunNumber">Crime Gun ID</option>
              <option value="LegacyCGICGunID">Legacy Gun ID</option>
            </select>
            <div class="invalid-feedback">
              Please select a search type.
            </div>
          </div>
          <div class="col-12">
            <label for="searchTerm" class="form-label required-field">{{labelForSearchTerm}}</label>
            <input id="searchTerm" type="text" class="form-control" #searchTerm formControlName="SearchTerm" required aria-required="true" minlength="4" />
            <div class="invalid-feedback">
              <p *ngIf="searchForm.get('SearchTerm').hasError('required') && searchFieldSelect.value != 'FTSID'">Please enter a search term.</p>
              <p *ngIf="searchForm.get('SearchTerm').hasError('minlength')">{{labelForSearchTermErrorMessageMinLength}}</p>
              <p *ngIf="searchForm.get('SearchTerm').hasError('FTSIDValidatorInvalid')">{{labelForSearchTermErrorMessageFTSID}}</p>
            </div>
          </div>
          <div class="col-12" [class.align-self-center]="searchForm.invalid" [class.align-self-end]="searchForm.valid">
            <button type="button" class="btn btn-success" [disabled]="searchForm.invalid || searching" (click)="onSearch()">Search</button>
            <button type="button" class="btn btn-secondary" (click)="onClear()">Cancel</button>
            <ng-container *ngIf="isCDSGuest">
              <ness-info-tooltip #cf tooltipStyleClass="p-tooltip-text-width-400">
                <div class="font-size-sm">
                  <div>Searching will yield results from your agency and any agencies with whom your agency has a CDS agreement.</div>
                  <br/>
                  <div>Your agency has an agreement with the following agencies:</div>

                  <ul>
                    <li *ngFor="let virtualGroup of cdsVirtualGroups">
                      {{virtualGroup.VirtualGroupName}}
                    </li>
                  </ul>
                
                  <div>If you have questions about CDS, please send an email to NESS_Support&#64;atf.gov.</div>
                </div>
              </ness-info-tooltip>
            </ng-container>
          </div>
        </div>
      </form>
    </div>
  </div>
  <ness-search-results [searchResults]="searchResults" [currentUserType]="currentUserType" [loading]="loading" [messageTemplate]="messageTemplate" [loadingStartRow]="loadingStartRow" [loadingEndRow]="loadingEndRow" (selectedResult)="onSelectedResult($event)"></ness-search-results>
</section>
<aside>
  <p-sidebar #sb (onShow)="onShowSidebar(sb);" (onHide)="clearSidebar()" [(visible)]="showSidebar" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
    <ng-container *ngIf="event$ | async as event">
      <ness-event-detail *ngIf="showEventDetail" #viewEvent (showEventDetail)="showSidebar = showEventDetail = false;" [event]="event" [hasEditPermission]="false" [returnRoute]="{commands: ['/search'], extras: returnRouteNavigationExtras}"></ness-event-detail>
    </ng-container>
    <ng-container *ngIf="crimeGunCustomFields$ | async as gunDetailCustomFields">
      <p-messages key="firearmCrimeGunMsg" [closable]="true" (valueChange)="showSidebar = showFirearmData = false"></p-messages>
      <ng-container *ngIf="hasVirtualRelationToFirearm; else viewfirearm">
        <ng-container *removeIfNoPermission="canEditCrimeGunFirearm; else viewfirearm">
          <ness-crime-gun-firearm *ngIf="showFirearmData" [displayLegacyGunID]="false" [gunDetailCustomFields]="gunDetailCustomFields" [states]="lookupService.usStates$ | async" (onFirearmUpdate)="onFirearmUpdate($event)" (closeFirearmView)="closeFirearmView()" (refreshFirearm)="closeFirearmView()" (refreshTraceData)="showCrimeGunCustomFields(gunDetailCustomFields.FirearmID)"></ness-crime-gun-firearm>
        </ng-container>
      </ng-container>
      <ng-template #viewfirearm>
        <ness-crime-gun-firearm-detail *ngIf="showFirearmData" [gunDetailCustomFields]="gunDetailCustomFields" (closeFirearmView)="closeFirearmView()"></ness-crime-gun-firearm-detail>
      </ng-template>
    </ng-container>
    <ng-container>
      <p-messages key="nibinCaseDataMsg" [closable]="true" (valueChange)="showSidebar = showNIBINCaseData = false"></p-messages>
      <ness-nibin-case-data *ngIf="showNIBINCaseData" (showDetails)="onShowDetails($event)" (showNIBINCaseData)="showSidebar = showNIBINCaseData = false"></ness-nibin-case-data>
    </ng-container>
  </p-sidebar>
</aside>
